module.exports = __webpack_public_path__ + "static/img/2.39b56739.png";